




import { apiRequest } from "./axiosInstance";


export const getOrderApi = async (params)=>{
    const response = await apiRequest({
        url: "/order/getAllOrders",
        method: "GET",
        params:params
      });
      return response?.data
}


export const getUserStatsFromOrders = async (companyId) => {
  const response = await apiRequest({
    url: '/order/userStats',
    method: 'GET',
    params: { companyId },
  });
  return response?.data;
};

export const createOrderApi = async (id,body) => {
  try {
    // let data= await axios.post(`${baseUrl}/user/createUser`,userdata)

    const data = await apiRequest({
      url: `/order/createOrder?companyId=${id}`,
      method: "POST",
      data: body,
    });
    return {success:true,message:'created successfully!'};
  } catch (error) {
    console.log(error, "error");
    return {message:error?.response?.data?.message,success:false};
  }
};